import { Injectable } from '@angular/core';
import { IID_ISSUE_LINK } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDIssueLinkStore } from './iidIssueLink.store';
import { IIDIssueLinkQuery } from './iidIssueLink.query';
import { WsACKCallback } from '@common/api/ack';
import { IIssue } from '@common/interfaces/issue';
import { RealtimeFeatureCommandService } from '@ep-om/realtime-v2';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.ISSUE_LINK)
export class IIDIssueLinkService extends CrudService<IID_ISSUE_LINK, IIDIssueLinkStore, IIDIssueLinkQuery> {
  constructor(
    protected store: IIDIssueLinkStore,
    public query: IIDIssueLinkQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
    private featureCommandService: RealtimeFeatureCommandService,
  ) {
    super(
      Topics.IID_ISSUE_LINK,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

  createIssueAndLink(issue: Partial<IIssue>, parentIssueId: string, typeInterfaceFrom: string, callback?: WsACKCallback<void>) {
    const dto = { issue, parentIssueId, typeInterfaceFrom };
    this.featureCommandService.send(
      {
        target: 'feature:issue-link',
        command: 'create-issue-and-link',
        dto,
        projectId: issue.projectId,
      },
      () => this.actionService.sendMessage(Topics.IID_ISSUE_LINK, 'createIssueAndLink', dto, callback),
      callback,
    );
  }

  createLink(linkToCreate: Partial<IID_ISSUE_LINK>, callback?: WsACKCallback<void>) {
    this.featureCommandService.send(
      {
        target: 'feature:issue-link',
        command: 'create-link',
        dto: linkToCreate,
        projectId: linkToCreate.projectId,
      },
      () => this.actionService.sendMessage(Topics.IID_ISSUE_LINK, 'createLink', linkToCreate, callback),
      callback,
    );
  }

  updateValidity(issueId: string, issueTypeInterfaceName: string, callback?: WsACKCallback<void>) {
    const dto = { issueId, issueTypeInterfaceName };
    this.featureCommandService.send(
      {
        target: 'feature:issue-link',
        command: 'update-validity',
        dto,
        ...this.projectIdFromIssue(issueId),
      },
      () => this.actionService.sendMessage(Topics.IID_ISSUE_LINK, 'updateValidity', dto, callback),
      callback,
    );
  }

  deleteLink(linkToDeleteId: string, callback?: WsACKCallback<void>) {
    const dto = { id: linkToDeleteId };
    const projectId = this.query.getEntity(linkToDeleteId)?.projectId;
    this.featureCommandService.send(
      {
        target: 'feature:issue-link',
        command: 'delete-link',
        dto,
        ...(projectId && { projectId }),
      },
      () => this.actionService.sendMessage(Topics.IID_ISSUE_LINK, 'deleteLink', dto, callback),
      callback,
    );
  }

  private projectIdFromIssue(issueId: string): { projectId?: string } {
    const projectId = this.query.getAll().find(link => link.issueId === issueId)?.projectId;
    return projectId ? { projectId } : {};
  }
}
